import { createSelector } from "@reduxjs/toolkit";

import { selectSelectedFacets } from "../../../../facets/redux/selectors/select-selected-facets";
import { applyFacetsToResults } from "../../../../facets/functions/filtering/apply-facets-to-results";
import { selectSortedResults } from "../sorting/select-sorted-results";

export const selectFacetedResults = createSelector(
	[selectSortedResults, selectSelectedFacets],
	(unprocessedResults, selectedFacets) => {
		return applyFacetsToResults(unprocessedResults, selectedFacets);
	},
);
